import React, { useState, useEffect } from "react"
import Autocomplete from "react-google-autocomplete"
import { navigate } from "gatsby"
import SearchForm from "./search"

const BlogSearchComponent = props => {
  const [keyword, setkeyword] = useState("")
  const [firsturl, setfirsturl] = useState("/blog-search/?query=Chennai")

  const [url, seturl] = useState("")

  const doSomething = keyword => {
    setkeyword(keyword)
    var url = "/blog-search/?query=" + keyword
    seturl(url)
  }

  const SearchResult = () => {
    seturl(firsturl)
    navigate(url)
  }
  return (
    <div>
      <div className="homePageSearch">
        <div style={{ display: "inline" }}>
          <div className="input-group-alter-home">
            <label htmlFor="SearchLocation">Find the blog..</label>
            <input
              className="form-control homesearchformnew"
              placeholder="Search blog..."
              name="SearchLocation"
              value={keyword}
              onChange={e => {
                doSomething(e.currentTarget.value)
              }}
            />
            <button
              onClick={SearchResult}
              className="BlogSearchButton"
              value="Search"
            >
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default BlogSearchComponent
